

















import LazyHydrate from 'vue-lazy-hydration';
import {
  defineComponent,
  defineAsyncComponent,
  computed,
  useRoute,
  useRouter,
} from '@nuxtjs/composition-api';
import { useCart, useUiState, useWebsiteCode } from '~/composables';
import AppHeader from '~/components/AppHeader.vue';
import IconSprite from '~/components/General/IconSprite.vue';
import LoadWhenVisible from '~/components/utils/LoadWhenVisible.vue';

export default defineComponent({
  name: 'DefaultLayout',
  nuxtI18n: {
    seo: false
  },
  head() {
    return {
      link: [
        {
          rel: 'canonical',
          href: process.env.VSF_WEBSITE_CODE
            ? `https://togas.com/${process.env.VSF_WEBSITE_CODE}${this.$route.path}`
            : `https://togas.at${this.$route.path}`
        },
        {
          rel: 'alternate',
          hreflang: 'x-default',
          href: process.env.VSF_WEBSITE_CODE
            ? 'https://togas.com/'
            : 'https://togas.at/'
        },
      ]
    };
  },
  components: {
    LoadWhenVisible,
    LazyHydrate,
    AppHeader,
    IconSprite,
    AppFooter: () => import(/* webpackPrefetch: true */ '~/components/AppFooter.vue'),
    LoginModal: () => import(/* webpackPrefetch: true */ '~/modules/customer/components/LoginModal/LoginModal.vue'),
    Notification: () => import(/* webpackPrefetch: true */ '~/components/Notification.vue'),
  },
  setup() {
    const { isLoginModalOpen, isCartSidebarOpen, toggleLoginModal } = useUiState();
    const { cart } = useCart();
    const { isUs } = useWebsiteCode();
    const route = useRoute();
    const router = useRouter();

    const cartSidebar = computed(() =>
      defineAsyncComponent(() =>
        isUs.value
          ? import(/* webpackChunkName: "cart-sidebar-us" */ '~/modules/checkout/components/cart/CartSidebarUS.vue')
          : import(/* webpackChunkName: "cart-sidebar" */ '~/modules/checkout/components/cart/CartSidebar.vue')
      )
    );

    const isContentCenterClass = computed(() => route.value.path === '/checkout/payment-processing' ? 'payment-resolver-class' : '');
    const cartClass = computed(() => {
      if (!route.value.fullPath.startsWith('/cart')) return '';
      if (!isUs.value) return '';

      return cart.value?.total_quantity > 0 ? 'cart-not-empty' : 'cart-empty';
    });

    // Mindbox
    router.afterEach((to) => {
      if (to.name) {
        if (window['PopMechanic'] && window['PopMechanic'].update) {
          window['PopMechanic'].update();
        }
      }
    });

    return {
      cartSidebar,
      isCartSidebarOpen,
      isLoginModalOpen,
      toggleLoginModal,
      route,
      isContentCenterClass,
      cartClass
    };
  },
  jsonld() {
    return {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      'name': 'Togas Online',
      'description': 'Gorgeous home textiles, innovative sleep products and designer home goods available to buy online.',
      'url': 'https://togas.com/',
      'logo': 'https://togas.com/int/logo.png',
      'department': [
        {
          '@type': 'Store',
          'name': 'Europe Customer Service',
          'telephone': '+302109606616',
          'openingHoursSpecification': [
            {
              '@type': 'OpeningHoursSpecification',
              'dayOfWeek': [
                'Monday',
                'Wednesday',
              ],
              'opens': '10:00',
              'closes': '18:00'
            },
            {
              '@type': 'OpeningHoursSpecification',
              'dayOfWeek': [
                'Tuesday',
                'Thursday',
                'Friday'
              ],
              'opens': '10:00',
              'closes': '21:00'
            },
            {
              '@type': 'OpeningHoursSpecification',
              'dayOfWeek': [
                'Saturday'
              ],
              'opens': '10:00',
              'closes': '16:00'
            }
          ]
        },
        {
          '@type': 'Store',
          'name': 'USA Customer Service',
          'telephone': '+12123002876',
          'openingHoursSpecification': [
            {
              '@type': 'OpeningHoursSpecification',
              'dayOfWeek': [
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday'
              ],
              'opens': '10:00',
              'closes': '18:00'
            },
            {
              '@type': 'OpeningHoursSpecification',
              'dayOfWeek': [
                'Sunday'
              ],
              'opens': '11:00',
              'closes': '17:00'
            },
          ]
        },
        {
          '@type': 'Store',
          'name': 'Middle East Customer Service',
          'telephone': '+971(0)43200773',
          'openingHoursSpecification': [
            {
              '@type': 'OpeningHoursSpecification',
              'dayOfWeek': [
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday',
                'Sunday'
              ],
              'opens': '10:00',
              'closes': '21:00'
            }
          ]
        }
      ]
    };
  },
});
